import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box } from "@mui/material";


const RoleFilter = (props: any) => {
    return (
        <div style={{
            position: "relative", display: "inline-block",
        }}>
            <div style={{ borderRadius: "24px", marginRight: '10px' }}>
                <Box component="form" noValidate >
                    <FormControl sx={{ minWidth: 144, height: 42, borderRadius: 24 }}>
                        <Select
                            onChange={props.roleFilteredChangeHandler}
                            value={props.filteredRole}
                            displayEmpty
                            inputProps={
                                { "aria-label": "Without label" }
                            }
                            style={{ borderRadius: "24px", height: '42px' }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        borderRadius: '24px',
                                    },
                                },
                            }}
                        >
                            <MenuItem value="" disabled>
                                Select Role
                            </MenuItem>
                            {props.roleOptions.map((option: any) => (
                                <MenuItem value={option.key} key={option.key} >{option.value}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </div>

        </div>
    );
}
export default RoleFilter;

